import { useEffect, useMemo, useState } from "react";
import SectionHeader from "../SectionHeader";
import { http } from "../../axios/axios";
import { Link } from "react-router-dom";
import { GetImageUrl } from "../../helpers/GetImageUrl";
import { Box, Loader2 } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const ClientSection = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

 

  // 10 clients in each slide
  const CLIENTS_PER_SLIDE = 10;

  const handleFetch = async () => {
    try {
      setLoading(true);

      const response = await http.get("/clients");

      const data = response.data?.data || [];

      setClients(data);
    } catch (error) {
      console.log(
        "Client fetch error:",
        error.response?.data || error.message
      );

      setClients([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetch();
  }, []);

  // Split all clients into groups of 10
  const clientSlides = useMemo(() => {
    const slides = [];

    for (
      let i = 0;
      i < clients.length;
      i += CLIENTS_PER_SLIDE
    ) {
      slides.push(
        clients.slice(i, i + CLIENTS_PER_SLIDE)
      );
    }

    return slides;
  }, [clients]);

  return (
    <section className="px-4 sm:px-6 lg:px-8 py-6">
      <SectionHeader
        badge="Trusted Worldwide"
        title="Our Clients"
        description="Join hundreds of businesses that trust us. Request your catalog and schedule a free consultation today"
        showLine={true}
      />

      {loading ? (
        <div className="py-20 flex justify-center">
          <Loader2
            className="animate-spin text-blue-600"
            size={38}
          />
        </div>
      ) : clientSlides.length > 0 ? (
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1}
          spaceBetween={30}
          speed={800}
          loop={clientSlides.length > 1}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          pagination={{
            clickable: true,
          }}
          className="mt-10 pb-12"
        >
          {clientSlides.map(
            (slideClients, slideIndex) => (
              <SwiperSlide key={slideIndex}>
                <div
                  className="
                    grid
                    grid-cols-2
                    sm:grid-cols-3
                    md:grid-cols-4
                    xl:grid-cols-5
                    gap-6
                    md:gap-8
                  "
                >
                  {slideClients.map((item) => (
                    <div
                      key={item._id}
                      className="
                        h-32
                        md:h-40
                        flex
                        items-center
                        justify-center
                        bg-white
                        rounded
                        border
                        border-slate-200
                        p-6
                        overflow-hidden
                      "
                    >
                      <img
                        loading="lazy"
                        decoding="async"
                        src={GetImageUrl(item.image)}
                        alt={
                          item.name ||
                          "Suraksha 24x7 client logo"
                        }
                        className="
                          max-h-full
                          max-w-full
                          object-contain
                          scale-105
                          hover:scale-110
                          transition-transform
                          duration-300
                          rounded
                        "
                      />
                    </div>
                  ))}
                </div>
              </SwiperSlide>
            )
          )}
        </Swiper>
      ) : (
        <div
          className="
            py-20
            text-center
            border
            border-dashed
            border-slate-300
            rounded-2xl
            bg-slate-50
          "
        >
          <Box
            size={40}
            className="mx-auto text-slate-300 mb-4"
          />

          <h3 className="text-lg font-semibold text-slate-700 mb-2">
            No Clients Available
          </h3>

          <p className="text-sm text-slate-500">
            Client information will appear here.
          </p>
        </div>
      )}

      {clients.length > CLIENTS_PER_SLIDE && (
        <div className="flex justify-center mt-4">
          <Link
            to="/clients"
            className="
              inline-flex
              items-center
              gap-2
              px-5
              py-3
              rounded-lg
              bg-blue-600
              text-white
              text-sm
              font-semibold
              hover:bg-blue-700
              transition
            "
          >
            View All Clients
          </Link>
        </div>
      )}
    </section>
  );
};

export default ClientSection;